// extracted by mini-css-extract-plugin
module.exports = {"card-summary":"card-summary__2psag","agreement":"agreement__1tzdP"};